import { api } from "./api";

export const getEnquiryList = async (addUrl = "") => {
  let url = `/enquiryHome?${addUrl}`;
  return await api.get(url);
};
export const getDemoList = async (addUrl = "") => {
  let url = `/enquiry/demo/student?${addUrl}`;
  return await api.get(url);
};
export const NewEnquiry = async (data) => {
  return await api.post("newEnquiry", data);
};

export const EnquiryDelete = async (id) => {
  return await api.get(`enquiry/delete/${id}`);
};
export const EnquiryStudentResponse = async (data) => {
  return await api.post(`add_Enquiry_response`, data);
};
export const EnquiryStatusUpdate = async (data) => {
  return await api.post(`update/enquiry/status`, data);
};

export const StateDistric = async (data) => {
  return await api.get(`states/district/view`, data);
};

export const EnquiryViewById = async (id) => {
  return await api.get(`enquiry/view/${id}`);
};

export const EnquiryUpdateById = async (data) => {
  return await api.post(`EditEnquiryPost`, data);
};

export const followlist = async (data) => {
  return await api.get(`/enquiry/follow/list`, data);
};

export const studentlist = async (data) => {
  return await api.get(`/student/follow/list`, data);
};

export const followresponse = async (data) => {
  return await api.post(`/add_follow_response`, data);
};

// fetch creator

export const listCreator = async () => {
  return await api.get(`/enquiry/add/staff/data`);
};

// fetch counselor

export const listCounselor = async (data) => {
  return await api.get(`counselor/list`, data);
};
